<ng-container *ngIf="density.enabled">
  <section class="map-control-surface density-legend" aria-label="Relative density legend" cdkOverlayOrigin #legendOrigin="cdkOverlayOrigin">
    <div class="density-summary">
      <div class="density-gradient" [style.background]="density.gradient" role="img" aria-label="Relative density, low to high"></div>
      <div class="density-scale"><span>Low</span><span>High</span></div>
      <div *ngIf="density.error" class="br-mt-2" role="alert">
        <p class="br-small br-mb-2">{{ density.error }}</p>
      </div>
      <p *ngIf="density.hasLoaded && !density.objects.length" class="br-small br-mt-2 br-mb-0" role="status">No locations.</p>
    </div>
    <div class="density-controls">
      <mat-select id="density-source" class="br-form-control br-form-control--sm density-source" aria-label="Density source"
              [ngModel]="density.settings.source" (ngModelChange)="density.update({source: $event})">
        <mat-option value="customers" [disabled]="!density.canUse('customers')">Customers</mat-option>
        <mat-option value="leads" [disabled]="!density.canUse('leads')">Leads</mat-option>
      </mat-select>
      <button id="density-settings-trigger" type="button" class="map-control-button"
              (click)="settingsOpen = !settingsOpen" aria-label="Density settings" aria-haspopup="dialog"
              [attr.aria-expanded]="settingsOpen" [attr.aria-controls]="settingsOpen ? 'density-settings-panel' : null">
        <br-icon>settings</br-icon>
      </button>
    </div>
  </section>
  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="legendOrigin"
               [cdkConnectedOverlayOpen]="settingsOpen" [cdkConnectedOverlayHasBackdrop]="false"
               [cdkConnectedOverlayDisableClose]="true" [cdkConnectedOverlayPositions]="settingsPositions"
               [cdkConnectedOverlayPush]="true" [cdkConnectedOverlayViewportMargin]="8"
               [cdkConnectedOverlayFlexibleDimensions]="false"
               (attach)="focusSettings()" (overlayKeydown)="settingsKeydown($event)">
    <section id="density-settings-panel" class="map-control-surface density-settings-panel" role="dialog"
             aria-modal="false" aria-labelledby="density-settings-title" tabindex="-1">
      <header class="density-settings-heading">
        <strong id="density-settings-title">Density</strong>
        <button type="button" class="map-control-button" (click)="closeSettings()" aria-label="Close settings"><br-icon>close</br-icon></button>
      </header>
      <div class="density-settings-body"><app-density-settings [feature]="density"></app-density-settings></div>
    </section>
  </ng-template>
</ng-container>
